import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { LoginResult, LoginError, ILoginClassicWireModel, IIdentificationResult } from './agent-login.models'
import { EnvironmentService } from 'app/environment.service'
import { Router } from '@angular/router';
import { LayoutState } from 'app/shared/layout/layout-state';
import { HybridService } from 'app/shared/hybrid/hybrid.service';

@Injectable()
export class AgentLoginService {

    constructor(private http: HttpClient, private environmentService: EnvironmentService, private router: Router, private layoutState: LayoutState, public hybridService: HybridService) { }

    loginClassic(credentials): Observable<any> {
        const url = `/api/agent/login`
        return this.http.post(url, credentials)
    }

    loginBearer(username: string, password: string, agentName: string, salesOwnerId: string): Observable<any> {
        let p = new HttpParams()
            .set('grant_type', 'password')
            .set('username', username)
            .set('password', password)
            .set('reference', agentName)
            .set('salesOwnerId', salesOwnerId)
        return this.http.post(`${this.environmentService.getSbServiceUrl()}/token`, p)
    }

    getIdentity(bearer: string): Observable<IIdentificationResult> {
        let headers = { 'Authorization': `Bearer ${bearer}` }
        return this.http.get<IIdentificationResult>(`${this.environmentService.getSbServiceUrl()}/api/agent/whoami`, { headers })
    }

    login(username: string, password: string, agentName: string, stayLoggedIn: boolean, salesOwnerId: string): Observable<LoginResult> {
        const credentials: ILoginClassicWireModel = {
            username: username,
            password: password,
            reference: agentName,
            stayLoggedIn: stayLoggedIn,
            salesOwnerId: salesOwnerId
        }
        // Call LoginBearer first since it doesn't have side effects.
        return new Observable(s =>
            this.loginBearer(username, password, agentName, salesOwnerId).subscribe(
                bearerResponse => {
                    this.getIdentity(bearerResponse.access_token).subscribe(identity => {
                        this.loginClassic(credentials).subscribe(
                            () => s.next(new LoginResult(bearerResponse.access_token, identity.travelAgentCode)),
                            () => { s.error(new LoginError('5')) })
                    })
                }, bearerError => s.error(new LoginError(bearerError.error.error))))
    }

    public redirectToAgent(): void {
        this.hybridService.changeWindowLocation('/agent')
    }

    public checkUserExist(username: string, salesOwnerId: string) {
        const url = `${this.environmentService.getSbServiceUrl()}/api/agentpassword/validateagent`

        const params = {
            username,
            salesOwnerId
        }

        return this.http.post(url, params, { headers: this.jsonHeader() })
    }

    public resendPassword(username: string, salesOwnerId: string) {

        const url = `${this.environmentService.getSbServiceUrl()}/api/agentpassword/resend`

        const params = {
            username,
            salesOwnerId
        }

        return this.http.post(url, params, { headers: this.jsonHeader() })
    }

    private jsonHeader(): any {
        return { 'Content-Type': 'application/json' }
    }
}
